<template>
  <section>
    <h3 class="h-title">服务基础信息</h3>  
    <el-form class="e-form f-b" ref="cForm1" :model="cForm1" label-width="auto"  label-position="left" :rules="setpFormRules1">
      <el-form-item label="存储类型" prop="saveType">
        <el-select v-model="cForm1.saveType" placeholder="请选择存储类型" style="width: 100%">
          <el-option
            v-for="dict in typeOptions"
            :key="dict.dictValue"
            :label="dict.dictLabel"
            :value="dict.dictValue"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="服务类型" prop="serviceType">
        <el-select v-model="cForm1.serviceType" @change="getNode" placeholder="请选择服务类型" style="width: 100%">
          <el-option
            v-for="dict in serviceOptions"
            :key="dict.dictValue"
            :label="dict.dictLabel"
            :value="dict.dictValue"
          ></el-option>
        </el-select>
      </el-form-item>

      <!-- 资产信息披露公告 -->
      <div v-if="cForm1.serviceType">
        <h3>资产信息披露公告基本信息</h3>        
        <el-form-item v-if="cForm1.serviceType == '41'" label="资产持有人名称" prop="assetHolderName">
          <el-input v-model="cForm1.assetHolderName" disabled />
        </el-form-item>
        <el-form-item v-else label="信息披露方名称" prop="infoDisclosuresName">
          <el-input v-model="cForm1.infoDisclosuresName" disabled />
        </el-form-item>
        <el-form-item class="w-70" label="公告期限(天)" prop="noticePeriod" >
          <el-input-number v-model="cForm1.noticePeriod" controls-position="right" :precision="0" :step="1" :min="1" placeholder="请输入整数" style="width: 100%"></el-input-number>
        </el-form-item> 
        <el-form-item label="公告场所" prop="noticePlace">
          <el-select v-model="cForm1.noticePlace" placeholder="请选择公告场所" style="width: 100%">
            <el-option
              v-for="dict in placeOptions"
              :disabled="dict.dictValue != '1'"
              :key="dict.dictValue"
              :label="dict.dictLabel"
              :value="dict.dictValue"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="成员单位名称" prop="lawFirmObj">
          <el-select v-model="cForm1.lawFirmObj" @change="setLawFirm" value-key="nodeName" placeholder="请选择成员单位" style="width: 100%">
            <el-option
              v-for="dict in lawOptions"
              :key="dict.nodeId"
              :label="dict.nodeName"
              :value="dict"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="权威节点" prop="authorityNodeArr">
          <el-select v-model="cForm1.authorityNodeArr" 
          @remove-tag="changeNode" 
          @change="seteNode" multiple 
          filterable 
          @input.native="filterData"
          @clear="clearData"
          value-key="nodeName" placeholder="请选择权威节点" style="width: 100%">
            <el-option
              v-for="item in nodeOptions"
              :key="item.id"
              :label="item.nodeName"
              :disabled="item.isRequire == '0'"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item v-if="cForm1.serviceType == '41'" label="资产名称" prop="noticeName">
          <el-input v-model="cForm1.noticeName" :maxlength="30" placeholder="请输入<=30文字" />      
        </el-form-item>
        <el-form-item v-if="cForm1.serviceType == '42'" label="拟投资区域" prop="proposedInvestmentArea">
          <el-input v-model="cForm1.proposedInvestmentArea" :maxlength="30" placeholder="请输入<=30文字" />      
        </el-form-item>
        <el-form-item v-if="cForm1.serviceType == '43'" label="项目名称" prop="noticeName">
          <el-input v-model="cForm1.noticeName" :maxlength="30" placeholder="请输入<=30文字" />      
        </el-form-item>
        <el-form-item v-if="cForm1.serviceType == '42' || cForm1.serviceType == '43'" label="拟合作方式" prop="proposedCooperationMode">
          <el-input v-model="cForm1.proposedCooperationMode" :maxlength="30" placeholder="请输入<=30文字" />      
        </el-form-item>
        <!-- <el-form-item class="w-70" :label="cForm1.serviceType == '41'?'资产规模(元)': cForm1.serviceType == '42'?'拟投资资金规模(元)':'预算金额(元)'" prop="noticeRelateAmount" >
          <el-input-number v-model="cForm1.noticeRelateAmount" controls-position="right" :precision="2" :step="0.1" :min="0" placeholder="请输入数字，小数点后2位" style="width: 100%"></el-input-number>
        </el-form-item>  -->
        <el-form-item class="w-70" :label="cForm1.serviceType == '41'?'资产规模(万元)': cForm1.serviceType == '42'?'拟投资资金规模(万元)':'预算金额(万元)'" prop="noticeRelateAmount">
          <el-input-number v-model="cForm1.noticeRelateAmount" controls-position="right" :precision="4" :step="0.1" :min="0" placeholder="请输入数字，小数点后4位" style="width: 100%" @change="changeAmount"></el-input-number>
        </el-form-item> 
        <el-form-item class="w-70" label="共识金额(万元)" prop="consensusAmount">
          <el-input-number v-model="cForm1.consensusAmount" controls-position="right" :precision="4" :step="0.1" :min="0" placeholder="请输入数字，小数点后4位" style="width: 100%" @change="changeAmount"></el-input-number>
        </el-form-item> 

        <el-form-item label="资产类别" v-if="cForm1.serviceType == '41'" prop="assetType">
          <el-input v-model="cForm1.assetType" :maxlength="30" placeholder="请输入<=30文字" />      
        </el-form-item>
        <el-form-item label="资产相关" v-if="cForm1.serviceType == '41'" prop="assetRelate">
          <el-input v-model="cForm1.assetRelate" :maxlength="30" placeholder="请输入<=30文字" />      
        </el-form-item>

        <el-form-item class="w-70" label="预期投资回报率(%/年)" v-if="cForm1.serviceType == '42'" prop="expectedInvestment" >
          <el-input-number v-model="cForm1.expectedInvestment" controls-position="right" :precision="2" :step="0.1" :min="0" placeholder="请输入数字，小数点后2位" style="width: 100%"></el-input-number>
        </el-form-item> 
        <el-form-item label="拟投资标的" v-if="cForm1.serviceType == '42'" prop="proposedInvestmentAsset">
          <el-input v-model="cForm1.proposedInvestmentAsset" :maxlength="30" placeholder="请输入<=30文字" />      
        </el-form-item>
        <el-form-item label="拟投资期限" v-if="cForm1.serviceType == '42'" prop="proposedInvestmentPeriod">
          <el-input v-model="cForm1.proposedInvestmentPeriod" :maxlength="30" placeholder="请输入<=30文字" />      
        </el-form-item>
        <el-form-item label="项目所在地" v-if="cForm1.serviceType == '43'" prop="projectLocation">
          <el-input v-model="cForm1.projectLocation" :maxlength="30" placeholder="请输入<=30文字" />      
        </el-form-item>
        <el-form-item label="合作方资质要求" v-if="cForm1.serviceType == '43'" prop="partnersQualifyRequire">
          <el-input v-model="cForm1.partnersQualifyRequire" :maxlength="30" placeholder="请输入<=30文字" />      
        </el-form-item>
        <el-form-item label="其他披露事项" prop="otherDisclosures">
          <el-input v-model="cForm1.otherDisclosures" rows="3" type="textarea" :maxlength="100" placeholder="请输入<=100文字" />      
        </el-form-item>
        <div v-if="showSubContract">
        <el-form-item label="从合同名称" prop="subContractName" :rules="[{required: true,message:'请输入',trigger:'blur'}]">
          <el-input v-model="cForm1.subContractName" :maxlength="50" placeholder="请输入<=50文字"/>
        </el-form-item>
        <el-form-item label="从合同编号" prop="subContractNo" :rules="[{required: true,message:'请输入',trigger:'blur'}]">
          <el-input v-model="cForm1.subContractNo" :maxlength="50" placeholder="请输入<=50文字"/>
        </el-form-item>
        <el-form-item label="从合同期限" prop="subContractPeriod" :rules="[{required: true,message:'请选择',trigger:'change'}]">
          <el-date-picker  style="width: 100%"
              format="yyyy-MM-dd" 
              value-format="yyyy-MM-dd"
              placeholder="请选择"
              v-model="cForm1.subContractPeriod"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item class="w-70" label="从合同金额(万元)" prop="subContractAmount" :rules="[{required: true,message:'请输入',trigger:'blur'}]">
          <el-input-number v-model="cForm1.subContractAmount" controls-position="right" @blur="conversion('subContractAmount')" :precision="4" :step="0.1" :min="0" placeholder="请输入数字，小数点后4位" style="width: 100%"></el-input-number>
        </el-form-item> 
        <el-form-item label="从合同签约主体1名称" prop="subContractSignName1" :rules="[{required: true,message:'请输入',trigger:'blur'}]">
          <el-input v-model="cForm1.subContractSignName1" :maxlength="50" placeholder="请输入<=50文字"/>
        </el-form-item>
        <el-form-item label="从合同签约主体2名称" prop="subContractSignName2" :rules="[{required: true,message:'请输入',trigger:'blur'}]">
          <el-input v-model="cForm1.subContractSignName2" :maxlength="50" placeholder="请输入<=50文字"/>
        </el-form-item>
        <div v-for="i in subContractSignNum" :key="'s'+i">
          <el-form-item :label="`从合同签约主体${i+2}名称`" :prop="`subContractSignName${i+2}`" :rules="[{required: true,message:'请输入',trigger:'blur'}]">
            <el-input v-model="cForm1['subContractSignName'+(i+2)]" :maxlength="50" placeholder="请输入<=50文字" style="width: 80%" />
            <el-button class="s-but" type="orange" @click="delSubNum(i)" style="width: 15%; margin: 0 0 0 5%">删除</el-button>
          </el-form-item>
        </div>

        <el-button v-show="subContractSignNum<10" class="s-but" style="margin-top:5px" icon="el-icon-plus" type="orange" @click="addSubNum">其他签约主体</el-button>
      </div>
      </div>
    </el-form>
    <!-- 按钮 -->					
    <div class="cenrer">	
      <el-button class="s-but" type="orange" @click="cSubmitForm('0')" :loading="butLoading">保 存</el-button>	
      <el-button class="s-but" type="orange" @click.native="cSubmitForm('1')" :loading="butLoading">下一步</el-button>
    </div>
  </section>
</template>

<script>
import baseUrl from '@/api/baseUrl.js'
import { elFormErrorScrollIntoView } from '@/utils/util'
export default {
    name: "step1",
    props: ["active", "id"],
		data() {
			return {    
        cForm1: {},
				setpFormRules1: {
          saveType: [
            { required: true, message: "请选择", trigger: "change" }
          ],
          serviceType: [
            { required: true, message: "请选择", trigger: "change" }
          ],
          assetHolderName: [
            { required: true, message: "请输入", trigger: "blur" },
          ],
          infoDisclosuresName: [
            { required: true, message: "请输入", trigger: "blur" },
          ],
          noticePeriod: [
            { required: true, message: "请输入", trigger: "blur" },
          ],
          noticePlace: [
            { required: true, message: "请选择", trigger: "change" },
          ],
          lawFirmObj: [
            { required: true, message: "请选择", trigger: "change" }
          ],
          authorityNodeArr: [
            { required: true, message: "请选择", trigger: "change" }
          ],
          noticeName: [
            { required: true, message: "请输入", trigger: "blur" },
          ],
          proposedInvestmentArea: [
            { required: true, message: "请输入", trigger: "blur" }
          ], 
          proposedCooperationMode: [
            { required: true, message: "请输入", trigger: "blur" }
          ],          
          noticeRelateAmount: [
            { required: true, message: "请输入", trigger: "blur" }
          ],
          consensusAmount:[
            { required: true, message: "请输入", trigger: "blur" }
          ],
          assetType: [
            { required: true, message: "请输入", trigger: "blur" }
          ],
          expectedInvestment: [
            { required: true, message: "请输入", trigger: "blur" }
          ],
          proposedInvestmentAsset: [
            { required: true, message: "请输入", trigger: "blur" }
          ],
          proposedInvestmentPeriod: [
            { required: true, message: "请输入", trigger: "blur" }
          ],
          projectLocation: [
            { required: true, message: "请输入", trigger: "blur" }
          ],
          partnersQualifyRequire: [
            { required: true, message: "请输入", trigger: "blur" }
          ]
        },
        butLoading: false,       
        account: sessionStorage.account,
        lawOptions: [],
        nodeOptions: [],
        placeOptions: [],
        nodeTotal: 0,
        typeOptions: [],
        serviceOptions: [],
        curServiceType: '',
        showSubContract:false,
        subContractSignNum: 0,
        queryParams: {
          pageNum: 1,
          pageSize: 1000,
          status: '0'
        }
			}
    },
    watch: {
      active(newVal) {
        if(newVal == 1) {
          window.scrollTo(0,0);
          var param = JSON.parse(sessionStorage.setpForm);
          param.noticeRelateAmount = param.noticeRelateAmount/10000
          param.consensusAmount = param.consensusAmount/10000
          param.subContractAmount = param.subContractAmount/10000
          this.cForm1 = param;
          this.getLawFirm()
          this.getNodeList()
          this.init()
        } 
      }
    },
    mounted(){
      this.action = `${baseUrl.iaccUrl}/iacc-contract-platform/common/uploadFile`;
      this.$api.api.getDicts("gsgg_save_type").then(response => {
          this.typeOptions = response.data;
      });
      this.$api.api.getDicts("gsgg_service_type").then(response => {
          this.serviceOptions = response.data;
      });
      this.$api.api.getDicts("gsgg_place").then(response => {
          this.placeOptions = response.data;
      });
      if(this.id) {
        this.getDetial();
      }          
      
    },
    methods: {
      init(){
        // 金额
        if(this.cForm1.noticeRelateAmount == null){
          delete this.cForm1.noticeRelateAmount
        }
        if(this.cForm1.expectedInvestment == null){
          delete this.cForm1.expectedInvestment
        }
        if(this.cForm1.subContractPeriodStart){
          this.$set(this.cForm1, 'subContractPeriod', [this.cForm1.subContractPeriodStart, this.cForm1.subContractPeriodEnd]) 
          this.changeAmount()     
        }
      },
      getNode(){
        if(this.curServiceType == this.cForm1.serviceType){
          this.getDetial();
        }else {
          this.cForm1 = {
            saveType: this.cForm1.saveType,
            serviceType: this.cForm1.serviceType
          };     
          this.getLawFirm()
          this.getNodeList()
          this.init()
          this.changeAmount() 
          if(this.cForm1.serviceType == '41'){
            this.cForm1.assetHolderName = sessionStorage.projectName 
          }else {
            this.cForm1.infoDisclosuresName = sessionStorage.projectName   
          }
        }               
      },
      // 查询权威节点
      filterData(e){
        this.queryParams.pageNum = 1
        this.queryParams.nodeName = e.target.value;
        this.selectNode();
      },
      // 清空权威节点
      clearData() {
        this.queryParams.nodeName = ""
        this.queryParams.pageNum = 1
        this.selectNode();
      },
      selectNode(){
        this.$api.api.nodeList({...this.queryParams, nodeType: '1', businessType: this.cForm1.serviceType}).then(response => {
          if(response.code == 200){
            this.nodeOptions = response.rows
          }else {
            this.$message.error(response.msg);
          } 
        })
      },
      //获取详情
      getDetial() {
          this.$api.announcement.anDetail(this.id).then(res => {
              if(res.code==200){
                  this.cForm1 = Object.assign({}, res.data); 	
                  this.curServiceType = this.cForm1.serviceType             
                  this.getLawFirm()
                  this.getNodeList()
                  this.init()
              }else {
                  this.$message.error(res.msg);
              }    
          });      
      },
      //从合同是否展示
      changeAmount(){
        if(this.cForm1.consensusAmount && this.cForm1.noticeRelateAmount){
           this.showSubContract = (this.cForm1.consensusAmount !== this.cForm1.noticeRelateAmount)
           if(this.showSubContract && !this.cForm1.subContractName){
            this.$confirm('共识金额与资产规模金额不一致，请补充相关资料').then(_ => {})
            .catch(_ => {});
            
           }
        }else{
          this.showSubContract = false
        }
      },
      addSubNum(){
      this.subContractSignNum++
      },
      cSubmitForm(type){        
        // 用户经理
        this.cForm1.userManager = sessionStorage.applyCustomerName
        this.cForm1.userManagerPhone = sessionStorage.applyCustomerContact
        this.cForm1.userManagerAccount = sessionStorage.applyCustomerAccount
        this.cForm1.submitName = sessionStorage.projectName
        if(this.cForm1.subContractPeriod){
          this.cForm1.subContractPeriodStart = this.cForm1.subContractPeriod[0]
          this.cForm1.subContractPeriodEnd = this.cForm1.subContractPeriod[1]
         } 
        this.$refs["cForm1"].validate(valid => {
          if (valid) {
            if(this.nodeTotal >= 4){
              if(this.cForm1.authorityNodeArr.length !== 4){
                this.$message.error("权威节点请选择4个！");
                return false
              }
            }else {
              if(this.cForm1.authorityNodeArr.length !== this.nodeTotal){
                this.$message.error("权威节点请选择"+this.nodeTotal+"个！");
                return false
              }
            }
            this.cForm1.authorityNode = []
            this.cForm1.authorityNodeArr.forEach(item => {
              this.cForm1.authorityNode.push({
                id: item.id,
                name: item.nodeName
              })
            })
            this.cForm1.authorityNode = JSON.stringify(this.cForm1.authorityNode)
            var param = Object.assign({}, this.cForm1)
            param.noticeRelateAmount = param.noticeRelateAmount*10000
            param.consensusAmount = param.consensusAmount*10000
            if(this.showSubContract === true){
              param.subContractAmount = param.subContractAmount*10000
              param.consensusAmountRmb = this.smalltoBIG(param.consensusAmountRmb*10000) 
              param.subContractAmountRmb =  this.smalltoBIG(param.subContractAmountRmb*10000)
              console.log( this.smalltoBIG(param.consensusAmountRmb*10000) )
            }
            if(type == '0'){
              param.status = '0'
              this.$api.announcement.addAndUpd(JSON.stringify(param)).then(response => {
                this.butLoading = false;
                if(response.code == 200){
                  sessionStorage.removeItem("setpForm")
                  this.$message.success("保存成功");
                  this.$router.go(-1);
                }     
              });
            }else {
              sessionStorage.setpForm = JSON.stringify(param);
              this.$emit('next');
            }
            
          }else {
            this.$nextTick(() => {
              elFormErrorScrollIntoView()
            })
          }
        })
      },
      changeNode(item){
        if(item.isRequire == '0'){
          this.$message.error("此项为必须项，不能删除！");
          this.cForm1.authorityNodeArr.push(item)
        }
      },
      seteNode(obj){
        this.clearData()
        obj.forEach((item, i) => {
          if(item.nodeName == this.cForm1.lawFirmName){
            this.$message.error("律所与权威节点不能选择相同机构！");
            this.cForm1.authorityNodeArr.splice(i, 1)
          }
        })
      },
      setLawFirm(obj){
        // 律所与权威节点不能相同
        let index = this.cForm1.authorityNodeArr.findIndex((item) => item.nodeName === obj.nodeName); 
        if(index >= 0){
          this.$message.error("律所与权威节点不能选择相同机构！");
          delete this.cForm1['lawFirmObj']
        }else {
          this.cForm1.lawFirmName = obj.nodeName
          this.cForm1.lawFirm = obj.nodeId
        }      
      },
      getLawFirm(){
        this.$api.api.nodeList({...this.queryParams,nodeType:'2', businessType: this.cForm1.serviceType}).then(response => {
          if(response.code == 200){
            this.lawOptions = response.rows          
            if(this.cForm1.lawFirmName){
              this.$set(this.cForm1, 'lawFirmObj', {
                nodeName: this.cForm1.lawFirmName,
                nodeId: this.cForm1.lawFirm
              })
            }

          }else {
            this.$message.error(response.msg);
          }      
        });
      },
      uniqueFun(arr,type){
        const res = new Map();
        return arr.filter((a)=>!res.has(a[type])&& res.set(a[type],1));
      },
      getNodeList(){
        this.$api.api.nodeList({...this.queryParams, nodeType: '1', businessType: this.cForm1.serviceType}).then(response => {
          if(response.code == 200){
            this.nodeOptions = response.rows
            this.nodeTotal = response.total
            let authorityArr = []    
            this.nodeOptions.forEach(item => {
              if(item.isRequire == '0'){
                authorityArr.push({
                  id: item.id,
                  nodeName: item.nodeName
                })
              }
            })  
            if(this.cForm1.authorityNode){            
              let nodeArr = JSON.parse(this.cForm1.authorityNode)
              nodeArr.forEach(item =>{
                if(this.nodeOptions.findIndex((v) => {return v.id == item.id;}) >= 0){
                  authorityArr.push({
                    id: item.id,
                    nodeName: item.name
                  })
                }             
              })
            }    
            this.$set(this.cForm1, 'authorityNodeArr', this.uniqueFun(authorityArr, 'id')) 
          }else {
            this.$message.error(response.msg);
          }      
        });
      },
      /** 数字金额大写转换(可以处理整数,小数,负数) */    
    smalltoBIG(n){    
      let fraction = ['角', '分'];    
      let digit = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'];    
      let unit = [ ['元', '万', '亿'], ['', '拾', '佰', '仟']  ];    
      let head = n < 0? '欠': '';    
      n = Math.abs(n);    
    
      let s = '';    
    
      for (let i = 0; i < fraction.length; i++)     
      {    
          s += (digit[Math.floor(n * 10 * Math.pow(10, i)) % 10] + fraction[i]).replace(/零./, '');    
      }    
      s = s || '整';    
      n = Math.floor(n);    
    
      for (let i = 0; i < unit[0].length && n > 0; i++)     
      {    
          let p = '';    
          for (let j = 0; j < unit[1].length && n > 0; j++)     
          {    
              p = digit[n % 10] + unit[1][j] + p;    
              n = Math.floor(n / 10);    
          }    
          s = p.replace(/(零.)*零$/, '').replace(/^$/, '零')  + unit[0][i] + s;    
      }    
      return head + s.replace(/(零.)*零元/, '元').replace(/(零.)+/g, '零').replace(/^整$/, '零元整');    
    },
    }
	}
</script>